import { createModel } from 'hox'
import { inquiryResultService } from '../../inquiryResultService'
import { IOptions } from 'ahooks/lib/useCookieState'
import { IInquiryGoodsForContrast } from '@/views/inquiry/inquiryTypes'
import { useState } from 'react'
import { generateUniqueId } from '@/utils/utils'

export  interface IInquiryResultDetailItem {
        supplierCode?: string
        supplierName?: string
        code?: string
        list?: IInquiryGoodsForContrast[]
    }

export const useInquiryResultDetailModel = createModel(function () {
   

    const [mainData, setMainData] = useState<IInquiryResultDetailItem>({})
    const [oneData, setOneData] = useState<IInquiryResultDetailItem>({})
    const [twoData, setTwoData] = useState<IInquiryResultDetailItem>({})

    const getDetail = async (id: string) => {
        let { retData } = await inquiryResultService.one(id)
        const { inquiryCode, supplierCode, supplierName, sumInquiryDetailsResultList } = retData
        const inquiryCodeS = inquiryCode.split(',')
        const supplierCodeS = supplierCode.split(',')
        const supplierNameS = supplierName.split(',')
        let mainList:IInquiryGoodsForContrast[] = [], oneList:IInquiryGoodsForContrast[] = [], twoList:IInquiryGoodsForContrast[] = []
        sumInquiryDetailsResultList.forEach((item) => {
            mainList.push({
                id: item.id || generateUniqueId(),
                materialCode: item.materialCode1,
                materialName: item.materialName1,
                price: item.price1,
            })
            oneList.push({
                id: item.id || generateUniqueId(),
                materialCode: item.materialCode2,
                materialName: item.materialName2,
                price: item.price2,
                result: item.resultPrice1
            })
            twoList.push({
                id: item.id || generateUniqueId(),
                materialCode: item.materialCode3,
                materialName: item.materialName3,
                price: item.price3,
                result: item.resultPrice2
            })
        })

        setMainData({
            code: inquiryCodeS[0],
            supplierName: supplierNameS[0],
            supplierCode: supplierCodeS[0],
            list: mainList,
        })
        setOneData({
            supplierCode: supplierCodeS[1],
            supplierName: supplierNameS[1],
            code: inquiryCodeS[1],
            
            list: oneList,
        })
        setTwoData({
            supplierCode: supplierCodeS[2],
            supplierName: supplierNameS[2],
            code: inquiryCodeS[2],
            list: twoList,
        })
    }

    return {
        getDetail,
        mainData,
        oneData,
        twoData,
    }
})
